import { render, staticRenderFns } from "./SkuHistory.vue?vue&type=template&id=2c24ba20&scoped=true&"
import script from "./SkuHistory.vue?vue&type=script&lang=js&"
export * from "./SkuHistory.vue?vue&type=script&lang=js&"
import style0 from "./SkuHistory.vue?vue&type=style&index=0&id=2c24ba20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c24ba20",
  null
  
)

export default component.exports